import { theme } from "../../theme/theme";

export default theme;
